// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The CodeMirror token.
 */
export const ICodeMirror = new Token('@jupyterlab/codemirror:ICodeMirror');
//# sourceMappingURL=tokens.js.map